import React from 'react';
import ContactUs from '../../ContactUs/ContactUs';
import Team from '../../Team/Team';

const AboutUs = () => {
    return (
        <div className='bg-slate-50'>
            <Team />
            <ContactUs />
        </div>
    );
};

export default AboutUs;